import { render, staticRenderFns } from "./FloatingBallGroup.vue?vue&type=template&id=3272606e&scoped=true"
import script from "./FloatingBallGroup.vue?vue&type=script&lang=js"
export * from "./FloatingBallGroup.vue?vue&type=script&lang=js"
import style0 from "./FloatingBallGroup.vue?vue&type=style&index=0&id=3272606e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3272606e",
  null
  
)

export default component.exports